import { useEffect, useContext } from 'react';
import { useSettingsContext } from 'context/settingsContext';

export const useSettings = () => {
    const res = useSettingsContext();
    return { ...res };
};

export default useSettings;
